module.exports = __webpack_public_path__ + "img/Chest-2-2.c47ec5b6.png";